import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_PORTFOLIO_MODEL_NAME } from './portfolioModelBreadcrumb.query';

export function PortfolioModelBreadcrumb() {
  const { translateBackendString } = useLocalization();
  const { data } = useQuery(FETCH_PORTFOLIO_MODEL_NAME, {
    variables: { id: useParams().id },
  });

  // Return just the model name; SmartBreadcrumb wraps it in an org-aware Link
  // using the route pathname, so it owns navigation for this crumb.
  return data
    ? translateBackendString(
        data.fetchModelPortfolio?.modelPortfolio.translatedName,
      ) || data.fetchModelPortfolio?.modelPortfolio.name
    : 'Model';
}
